export function downloadAttendanceReportTypePatcher(data) {
    return {
        __typename: 'ChildAttendanceReport',
        ...data,
    };
}
